import React, { useState } from "react";
import useFinancialTransactions from "../../hooks/useFinancialTransactions";
import { TRANSACTION_TYPES } from "../../constants/transactionTypes";
import TransactionForm from "../Revenue/TransactionForm";
import TransactionTable from "../Revenue/TransactionTable";
import styles from "./ExpensesTab.module.css";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";

const ExpensesTab = () => {
  const {
    transactions,
    loading,
    error,
    createTransaction,
    updateTransaction,
    deleteTransaction,
  } = useFinancialTransactions(TRANSACTION_TYPES.EXPENSE);

  const [editingItem, setEditingItem] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // حذف
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const handleSubmit = async (data) => {
    if (editingItem) {
      await updateTransaction(editingItem.id, data);
    } else {
      await createTransaction(data);
    }

    setShowForm(false);
    setEditingItem(null);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setShowForm(true);
  };

 const handleDelete = (item) => {
  setItemToDelete(item); // ده بقى رقم، مش object!
};

  const confirmDelete = async () => {
    if (!itemToDelete) return;

    try {
      setDeleting(true);

      await deleteTransaction(itemToDelete.id);

      setItemToDelete(null);
    } finally {
      setDeleting(false);
    }
  };

  const cancelDelete = () => {
    if (deleting) return;

    setItemToDelete(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>المصروفات</h3>

        <button
          onClick={() => {
            setEditingItem(null);
            setShowForm(true);
          }}
        >
          + إضافة مصروف
        </button>
      </div>

      {error && <p className={styles.error}>{error}</p>}

      {showForm && (
        <TransactionForm
          initialData={editingItem}
          onSubmit={handleSubmit}
          onCancel={() => {
            setShowForm(false);
            setEditingItem(null);
          }}
          submitLabel={editingItem ? "تحديث" : "إضافة"}
        />
      )}

      <TransactionTable
        transactions={transactions}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <ConfirmDialog
        isOpen={!!itemToDelete}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من حذف "${
          itemToDelete?.title ||
          itemToDelete?.name ||
          "هذا العنصر"
        }"؟ لا يمكن التراجع عن هذا الإجراء.`}
        loading={deleting}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
  );
};

export default ExpensesTab;